import type { PopoverContentProps } from '@radix-ui/react-popover'
import { CircleHelp } from 'lucide-react'
import type { PropsWithChildren } from 'react'
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from '~/components/ui/popover'
import { cn } from '~/lib/utils'

export type InfoPopoverProps = PropsWithChildren &
	Pick<PopoverContentProps, 'side' | 'align' | 'sideOffset'> & {
		classNames?: string
	}

export const InfoPopover = ({
	children,
	side = 'bottom',
	align = 'start',
	sideOffset = 5,
	classNames,
}: InfoPopoverProps) => (
	<Popover>
		<PopoverTrigger asChild>
			<button
				type='button'
				className={cn('group text-base text-primary', classNames)}
			>
				<CircleHelp size={16} />
			</button>
		</PopoverTrigger>

		<PopoverContent
			side={side}
			align={align}
			sideOffset={sideOffset}
			className='max-w-[320px] border px-2 py-1 text-sm'
		>
			{children}
		</PopoverContent>
	</Popover>
)
